module.exports = __webpack_public_path__ + "img/union_2.018c25b9.png";